import { baseApi } from "./baseApi";

const WAREHOUSING_BASE_URL = "/warehousing";

export const warehousingApi = baseApi.injectEndpoints({
  tagTypes: ["Warehousing"],

  endpoints: (builder) => ({
    addWarehousing: builder.mutation({
      query: (payload) => ({
        url: WAREHOUSING_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "Warehousing", id: _id },
        { type: "Warehousing", id: "LIST" },
      ],
    }),

    listWarehousing: builder.query({
      query: (params) => ({
        url: WAREHOUSING_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Warehousing",
              id: _id,
            })),
            { type: "Warehousing", id: "LIST" },
          ]
          : [{ type: "Warehousing", id: "LIST" }],
    }),

    getDDLWarehousing: builder.query({
      query: (params) => ({
        url: `${WAREHOUSING_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Warehousing",
              id: _id,
            })),
            { type: "Warehousing", id: "DDL" },
          ]
          : [{ type: "Warehousing", id: "DDL" }],
    }),

    getTransitShipmentsWithoutRoute: builder.query({
      query: (params) => ({
        url: `${WAREHOUSING_BASE_URL}/transit-without-route`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
            ...result.data.map(({ _id }) => ({
              type: "Warehousing",
              id: _id,
            })),
            { type: "Warehousing", id: "DDL" },
          ]
          : [{ type: "Warehousing", id: "DDL" }],
    }),

    getWarehousingDetail: builder.query({
      query: (id) => `${WAREHOUSING_BASE_URL}/${id}`,
      providesTags: (_result, _error, { _id }) => [
        { type: "Warehousing", id: _id },
        { type: "Warehousing", id: "LIST" },
      ],
    }),

    updateWarehousing: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${WAREHOUSING_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id: id }) => [
        { type: "Warehousing", id },
        { type: "Warehousing", id: "LIST" },
      ],
    }),
    listShipmentsByWarehousingId: builder.query({
      query: ({ warehousingId, page, limit }) => ({
        url: `${WAREHOUSING_BASE_URL}/${warehousingId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Warehousing", id: _id },
        { type: "Warehousing", id: "LIST" },
      ],
    }),
    // Get shipment dropdown list for Warehousing
    getDDLShipmentListForWarehousing: builder.query({
      query: (params) => ({
        url: `${WAREHOUSING_BASE_URL}/ddl/warehousing`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
            ...result.map(({ _id }) => ({
              type: "Shipment",
              id: _id,
            })),
            { type: "Shipment", id: "DDL" },
          ]
          : [{ type: "Shipment", id: "DDL" }],
    }),
  }),
});

export const {
  useAddWarehousingMutation,
  useListWarehousingQuery,
  useLazyListWarehousingQuery,
  useLazyGetDDLWarehousingQuery,
  useLazyGetTransitShipmentsWithoutRouteQuery,
  useGetWarehousingDetailQuery,
  useUpdateWarehousingMutation,
  useLazyGetDDLShipmentListForWarehousingQuery,

  useListShipmentsByWarehousingIdQuery,
  useLazyListShipmentsByWarehousingIdQuery,
} = warehousingApi;
